import { render, staticRenderFns } from "./RegionsAdd.vue?vue&type=template&id=792c10b6&"
import script from "./RegionsAdd.vue?vue&type=script&lang=js&"
export * from "./RegionsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports